import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
	titleContainer: {
		flexDirection: 'column',
		marginTop: 24,
	},
	reportTitle: {
		fontSize: 12,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
});

const InvoiceThankYouMsg = () => {
	const { t } = useTranslation();
	return (
		<View style={styles.titleContainer}>
			<Text style={styles.reportTitle}>{t('thankYouForDoingBusinessWithUs')}</Text>
			<Text style={styles.reportTitle}>************************************</Text>
			<Text style={styles.reportTitle}>{t('pleaseReferToOurWebsiteForAdditionalTerm')}</Text>
		</View>
	);
};

export default InvoiceThankYouMsg;
